import { Ticker } from 'components/base/Ticker'
import { CheckSvg } from '../svg/check'

export function TopExtendMenu04() {
  return (
    <div
      id='pc-menu-04'
      className='max-w-[1060px] w-full mx-auto relative d-mt-[68px]'
    >
      <div className='z-10 absolute inset-0 h-fit'>
        <img
          src='/images/top-extend/menu-02/roof.webp'
          alt='roof'
          className='object-contain d-w-[1060px] d-h-[156px]'
        />
        <div className='flex flex-col items-center w-full absolute inset-0 d-pt-[29px]'>
          <div className='bg-accent-green rounded-full absolute top-0 grid place-content-center transform -translate-y-1/2 d-w-[40px] d-h-[40px]'>
            <p className='font-semibold text-white d-text-[25px] d-leading-[25px]'>
              4
            </p>
          </div>
          <p className='d-text-[18px] d-leading-[38px] d-tracking-[1.8px]'>
            空いた時間が
          </p>
          <h3 className='font-semibold d-text-[32px] d-leading-[58px] d-tracking-[3.2px]'>
            楽しみに変わる
          </h3>
        </div>
      </div>

      <div className='w-full d-px-[30px]'>
        <div className='bg-white flex flex-col items-center d-pt-[172px] d-gap-[46px] pointer-events-none'>
          <div className='relative flex flex-col d-w-[1000px] items-center d-mt-[13px]'>
            <div className='w-full d-mt-[50px]'>
              <Ticker>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-01.webp'
                    alt='ticker-01'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-02.webp'
                    alt='ticker-02'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-03.webp'
                    alt='ticker-03'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-04.webp'
                    alt='ticker-04'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-05.webp'
                    alt='ticker-05'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-06.webp'
                    alt='ticker-06'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-07.webp'
                    alt='ticker-07'
                    className='object-contain'
                  />
                </div>
              </Ticker>
            </div>
            <div className='w-full d-mt-[20px]'>
              <Ticker>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-03.webp'
                    alt='ticker-03'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-04.webp'
                    alt='ticker-04'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-05.webp'
                    alt='ticker-05'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-06.webp'
                    alt='ticker-06'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-07.webp'
                    alt='ticker-07'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-02.webp'
                    alt='ticker-02'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-01.webp'
                    alt='ticker-01'
                    className='object-contain'
                  />
                </div>
              </Ticker>
            </div>
            <div className='w-full d-mt-[20px]'>
              <Ticker>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-01.webp'
                    alt='ticker-01'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-02.webp'
                    alt='ticker-02'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-03.webp'
                    alt='ticker-03'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-04.webp'
                    alt='ticker-04'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-05.webp'
                    alt='ticker-05'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-06.webp'
                    alt='ticker-06'
                    className='object-contain'
                  />
                </div>
                <div className='relative d-px-[10px] d-w-[177px] d-h-[105px]'>
                  <img
                    src='/images/top-extend/menu-04/pic-07.webp'
                    alt='ticker-07'
                    className='object-contain'
                  />
                </div>
              </Ticker>
            </div>

            <img
              src='/images/top-extend/menu-04/main.webp'
              alt='main'
              className='d-w-[304px] d-h-[396px] object-contain bottom-0 absolute'
            />

            <div
              aria-hidden
              className='d-w-[1000px] d-h-[250px] absolute bottom-0'
              style={{
                background:
                  'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFF 100%)',
              }}
            />
          </div>

          <div className='flex flex-col'>
            <p className='font-semibold mx-auto border-light-green w-fit d-text-[22px] d-leading-[40px] d-tracking-[2.2px] d-border-b-[5px]'>
              できること
            </p>
            <h4 className='font-semibold d-text-[34px] d-leading-[48px] d-tracking-[1.7px] d-mt-[24px]'>
              健康に役立つ記事・動画やイベントが満載！
            </h4>
            <div className='flex d-mt-[16px] d-gap-[8px]'>
              <CheckSvg className='d-w-[20px] d-h-[20px] d-mt-[5px]' />
              <p className='d-text-[18px] d-leading-[30px] d-tracking-[0.72px]'>
                健康などのマメ知識が満載
              </p>
            </div>
            <div className='flex d-mt-[8px] d-gap-[8px]'>
              <CheckSvg className='d-w-[20px] d-h-[20px] d-mt-[5px]' />
              <p className='d-text-[18px] d-leading-[30px] d-tracking-[0.72px]'>
                食や落語などジャンルも豊富
              </p>
            </div>
            <div className='flex d-mt-[8px] d-gap-[8px]'>
              <CheckSvg className='d-w-[20px] d-h-[20px] d-mt-[5px]' />
              <p className='d-text-[18px] d-leading-[30px] d-tracking-[0.72px]'>
                その他、あなたのウエルネスな行動を応援するイベントが盛りだくさん！
              </p>
            </div>

            <p className='d-mt-[24px] d-text-[12px] d-leading-[24px]'>
              ※画像は終了したイベントで、一部オトク継続便またはお試し中の方限定イベントも含みます。
              <br />
              ※イベントは不定期で登場します。最新のイベント内容はアプリでご確認ください。
            </p>
          </div>
        </div>

        <div className='bg-white flex items-center justify-center relative d-pb-[24px] d-gap-[34px]'>
          <img
            src='/images/top/afternoon/pc-afternoon-bus.webp'
            alt='bus'
            className='object-contain absolute d-w-[145px] d-bottom-[-25px] d-left-[-44px]'
          />

          <img
            src='/images/top/afternoon/pc-afternoon-bus-stop.webp'
            alt='bus-stop'
            className='object-contain absolute d-w-[162px] d-bottom-[-45px] d-right-[-58px]'
          />
        </div>
      </div>

      <img
        src='/images/top/morning/pc-morning-table.webp'
        alt='table'
        className='object-cover d-h-[39px] d-w-[1069px] d-rounded-[4px]'
      />
    </div>
  )
}
